import { render, staticRenderFns } from "./sample-detail.vue?vue&type=template&id=284bde6a&scoped=true"
import script from "./sample-detail.vue?vue&type=script&lang=js"
export * from "./sample-detail.vue?vue&type=script&lang=js"
import style0 from "./sample-detail.vue?vue&type=style&index=0&id=284bde6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284bde6a",
  null
  
)

export default component.exports